define('app/views/enamad_view',['app/setup'], function(takhfifan) {
  takhfifan.EnamadView = Backbone.View.extend({

    initialize: function() {
      var _this = this;
      $(window).one('scroll', function() {
        _this.loadIFrame(_this);
      });
    },

    loadIFrame: function(_this) {
      var $iframe = $('<iframe />')
        .prop('src', 'http://enamad.ir/trustseal/symbol.aspx')
        .prop('width', '125px')
        .prop('height', '140px')
        .prop('frameborder', '0')
        .css({'margin': '0', 'padding': '0', 'border': '0', 'display': 'none'});

      _this.$el.append($iframe);

      $iframe.one('load', function() {
        _this.$el.children('img').remove();
        $iframe.show();
      });

    }
  });

});

